export const DAY_EXERCISES = {
  1:  ["running"],
  2:  ["running"],
  3:  ["running"],
  4:  ["stretching"],
  5:  ["running"],
  6:  ["sentadilla", "zancada", "elevacion_talones", "plancha"],
  7:  ["running"],
  8:  ["stretching"],
  9:  ["running"],
  10: ["running"],
  12: ["running"],
  13: ["sentadilla", "zancada", "plancha"],
  14: ["running"],
  17: ["running"],
};

export const EXERCISE_DETAILS = {
  sentadilla: {
    name: "Sentadilla",
    musclesWorked: ["Cuádriceps", "Glúteos", "Core"],
    keys: [
      "Espalda recta en todo momento",
      "Rodillas no pasan la punta del pie",
      "Peso en los talones",
      "Baja hasta que los muslos estén a 90°",
      "Core (abdomen) activado",
    ],
  },
  zancada: {
    name: "Zancada",
    musclesWorked: ["Cuádriceps", "Glúteos", "Isquiotibiales"],
    keys: [
      "Torso erguido, no inclinarse",
      "Rodilla delantera a 90 grados",
      "Rodilla trasera casi toca el piso",
      "Paso controlado y estable",
      "Alternar piernas",
    ],
  },
  plancha: {
    name: "Plancha",
    musclesWorked: ["Core", "Hombros", "Espalda baja"],
    keys: [
      "Cuerpo en línea recta (cabeza a pies)",
      "No subir las caderas",
      "No hundir la espalda baja",
      "Abdomen apretado todo el tiempo",
      "Respirar con normalidad",
    ],
  },
  elevacion_talones: {
    name: "Elevación de talones",
    musclesWorked: ["Pantorrillas", "Gemelos", "Sóleo"],
    keys: [
      "Subir lo más alto posible sobre las puntas",
      "Mantener 2 segundos arriba",
      "Bajar lento y controlado",
      "Piernas rectas (no doblar rodillas)",
      "Control total del movimiento",
    ],
  },
  running: {
    name: "Técnica de carrera",
    musclesWorked: ["Piernas completas", "Core", "Cardiovascular"],
    keys: [
      "Inclinación ligera hacia adelante",
      "Brazos a 90° y relajados",
      "Pisada debajo del cuerpo (no adelante)",
      "Hombros relajados, no tensos",
      "Respirar: inhala 2 pasos, exhala 2 pasos",
      "Mirada al frente, no al suelo",
    ],
  },
  stretching: {
    name: "Estiramientos",
    musclesWorked: ["Cuádriceps", "Isquiotibiales", "Pantorrillas"],
    keys: [
      "Sin rebotes, mantener posición",
      "Mantener cada estiramiento 30 segundos",
      "Respirar profundo durante el estiramiento",
      "Nunca llegar al dolor, solo tensión",
      "Estirar ambos lados por igual",
    ],
  },
};
